import { useCallback, memo } from "react";
import "./StoreVariantSelection.scss";
import { Render } from "../../../../../../../../homepage/Render";
import { chunkArray, findPackageById, filterValidVariantOptions } from "../StoreUtils/storePackageUtils";

const StoreVariantSelection = (props) => {
  const { initialPackageVariants, selectedPackage, setSelectedPackage } = props;
  const handleSessionChange = useCallback(
    (packageId) => {
      if (!setSelectedPackage || typeof setSelectedPackage !== "function") {
        console.warn(
          "StoreVariantSelection: setSelectedPackage must be a function"
        );
        return;
      }

      if (!packageId) return;

      const options = initialPackageVariants?.quick_variants_selection_options;
      const selectedOption = findPackageById(
        packageId,
        options,
        initialPackageVariants
      );

      if (selectedOption) {
        setSelectedPackage(selectedOption);
      }
    },
    [initialPackageVariants, setSelectedPackage]
  );

  const chunkedOptions =
    initialPackageVariants?.show_quick_variants_selection_type === 1
      ? chunkArray(
          filterValidVariantOptions(
            initialPackageVariants?.quick_variants_selection_options || []
          ),
          2
        )
      : [];

  if (chunkedOptions.length === 0) {
    return null;
  }

  return (
    <Render if={true}>
      <div className="session-inner-wrapper">
        <div className="session-content-and-btn-wrapper">
          <h3>Select Packages</h3>
          <div className="session-options-wrapper">
            {chunkedOptions.map((row, rowIndex) => (
              <div key={rowIndex} className="session-row">
                {row.map((option) => (
                  <label
                    key={option.package_id}
                    className={`session-option ${
                      option.package_id === selectedPackage?.package_id
                        ? "session-option-active"
                        : ""
                    }`}
                  >
                    <input
                      type="radio"
                      name="session"
                      value={option.package_id}
                      checked={
                        option.package_id === selectedPackage?.package_id
                      }
                      onChange={() => handleSessionChange(option.package_id)}
                    />
                    <span className="radio-custom" />
                    <span className="session-details">
                      <span className="session-name">{option.title}</span>
                      <span className="session-validity">
                        Validity: {option.duration}
                      </span>
                    </span>
                    <span className="session-price">{option.price}</span>
                  </label>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Render>
  );
};

export default memo(StoreVariantSelection);
